import { Col, List, Row } from "antd";
import styled from "styled-components";

import { Palette } from "../../../core/styles/theme";

export const ListHeader = styled(Row)`
    padding: 10px 0px;
    width: 100%;
    color: ${Palette.HeroGreen};
    background-color: ${Palette.White};
`;

export const ListRow = styled(Row)`
    padding: 12px 0;
`;

export const ListItem = styled(List.Item)`
    margin: 0 !important;
    padding: 5px 24px !important;
    cursor: pointer;
    &:hover {
        color: ${Palette.HeroGreen};
    }
`;

export const CenteredContentCol = styled(Col)`
    text-align: center;
`;

export const RightContentCol = styled(Col)`
    text-align: right;
`;

export const ActionButton = styled("button")`
    margin-right: 10px;
    padding: 5px 15px;
    &:hover {
        color: white;
    }
`;

export const SaveButton = styled(ActionButton)`
    background-color: ${Palette.MenuScroll};
    color: ${Palette.AeviBlack};
`;

export const CancelButton = styled(ActionButton)`
    background-color: ${Palette.MenuScroll};
    color: ${Palette.AeviBlack};
`;

export const EditButton = styled(ActionButton)`
    background-color: ${Palette.MenuScroll};
    color: ${Palette.AeviBlack};
`;

export const DeleteButton = styled(ActionButton)`
    background-color: ${Palette.MenuScroll};
    color: ${Palette.AeviBlack};
`;

export const ButtonBar = styled(Row)`
    padding: 20px 0;
`;
